import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDownloadAuditTrailArtefact = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const downloadAuditTrailArtefact = async (auditTrailId: string) => {
    const response = await fetch(
      `${APIBaseChronos}/api/auditTrail/${auditTrailId}/artefact/download`,
      getFetchConfig({ method: FetchMethod.GET }),
    );

    if (!response.ok) {
      throw new Error('Failed to download audit trail artefact');
    }

    const contentDisposition = response.headers.get('Content-Disposition');
    const filenameMatch = contentDisposition?.match(/filename="(.+)"/);
    const filename = filenameMatch?.[1] ?? 'audit-trail-artefact.csv';
    const blob = await response.blob();
    const link = Object.assign(document.createElement('a'), {
      href: URL.createObjectURL(blob),
      download: filename,
    });

    link.click();
    URL.revokeObjectURL(link.href);
  };

  const { mutate: fetchDownload, isLoading: isLoadingDownload } = useMutation(downloadAuditTrailArtefact, {
    onError: () => {
      toast.error('Failed to download audit trail artefact. Please try again.');
    },
  });

  return { fetchDownload, isLoadingDownload };
};
